import React from 'react';
import { Link } from 'react-router-dom';
import { CONTACT_INFO, NAV_LINKS } from '../../data/mock';
import { ArrowRight, Phone, Clock, MapPin, Mail } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[rgb(0,55,32)] text-white">
      <div className="max-w-[1200px] mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 no-underline mb-4">
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#8FEC78] to-[#81DD67] flex items-center justify-center">
                <ArrowRight className="w-4 h-4 text-white" />
              </div>
              <span className="font-semibold text-base text-white">
                Beginning to End Tax
              </span>
            </Link>
            <p className="text-white/60 text-sm leading-relaxed mb-4">
              Nationwide tax preparation, tax education, and business structure guidance. 20+ years of experience. Headquartered in Phoenix, AZ.
            </p>
            <div className="flex flex-col gap-2">
              <a href={`tel:${CONTACT_INFO.phone}`} className="flex items-center gap-2 text-sm text-white/70 hover:text-[#8FEC78] transition-colors no-underline">
                <Phone className="w-4 h-4" /> {CONTACT_INFO.phone}
              </a>
              <span className="flex items-center gap-2 text-sm text-white/70">
                <Clock className="w-4 h-4" /> {CONTACT_INFO.hours}
              </span>
              <span className="flex items-start gap-2 text-sm text-white/70">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                <span>{CONTACT_INFO.address}<br />{CONTACT_INFO.cityStateZip}</span>
              </span>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-semibold text-sm text-white/90 mb-4 uppercase tracking-wider">Navigation</h4>
            <nav className="flex flex-col gap-2">
              {NAV_LINKS.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-sm text-white/60 hover:text-[#8FEC78] transition-colors no-underline"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-sm text-white/90 mb-4 uppercase tracking-wider">Services</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/services" className="text-sm text-white/60 hover:text-[#8FEC78] transition-colors no-underline">Personal Tax Prep</Link>
              <Link to="/services" className="text-sm text-white/60 hover:text-[#8FEC78] transition-colors no-underline">Business Tax Prep</Link>
              <Link to="/services" className="text-sm text-white/60 hover:text-[#8FEC78] transition-colors no-underline">Multi-State Returns</Link>
              <Link to="/services" className="text-sm text-white/60 hover:text-[#8FEC78] transition-colors no-underline">Amended Returns</Link>
              <Link to="/business-structure" className="text-sm text-white/60 hover:text-[#8FEC78] transition-colors no-underline">Business Structure</Link>
            </nav>
          </div>

          {/* Quick Actions */}
          <div>
            <h4 className="font-semibold text-sm text-white/90 mb-4 uppercase tracking-wider">Get Started</h4>
            <div className="flex flex-col gap-3">
              <Link
                to="/book"
                className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full bg-gradient-to-br from-[#8FEC78] to-[#81DD67] text-white font-semibold text-sm no-underline hover:shadow-lg transition-shadow"
              >
                Book Free Consult
              </Link>
              <Link
                to="/start-here"
                className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-full border border-white/20 text-white font-medium text-sm no-underline hover:bg-white/10 transition-colors"
              >
                Start Here
              </Link>
              <a
                href={`mailto:info@beginningtoendtax.com`}
                className="flex items-center gap-2 text-sm text-white/60 hover:text-[#8FEC78] transition-colors no-underline mt-1"
              >
                <Mail className="w-4 h-4" /> info@beginningtoendtax.com
              </a>
            </div>
          </div>
        </div>

        {/* Payment Methods */}
        <div className="border-t border-white/10 pt-6 mb-6">
          <p className="text-xs text-white/40 mb-2">Payment Methods Accepted</p>
          <p className="text-sm text-white/60">Invoice · Stripe · Square · Zelle · Cash App · Other options available on request</p>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/40">
            © {currentYear} Beginning to End Tax. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="text-xs text-white/40 hover:text-white/70 transition-colors no-underline">Privacy Policy</Link>
            <Link to="/terms" className="text-xs text-white/40 hover:text-white/70 transition-colors no-underline">Terms of Use</Link>
            <Link to="/disclaimer" className="text-xs text-white/40 hover:text-white/70 transition-colors no-underline">Tax Disclaimer</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
